import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <UpdatesSection />
        <FaqSection />
        <FeaturesSection />
        <IndexSection />
        <AppSection />
        <RankingSection />
        <CommentsSection />
        <ContactSection />
        <MediaSection />
        <AboutSection />
        <TopicsSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}